function fetchArrayBuffer(url: string, cb: (arraybuffer: ArrayBuffer) => unknown) {
  const xhr = new XMLHttpRequest();
  xhr.open('get', url);
  xhr.responseType = 'arraybuffer';
  xhr.onload = () => {
    cb(xhr.response);
  };
  xhr.send();
}

function download(url: string, fileName: string, contentType: string): void {
  fetchArrayBuffer(url, data => {
    const file = new Blob([data], { type: contentType });
    const fileUrl = window.URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(fileUrl);
  });
}

export function downloadPdf(url: string, fileName: string): void {
  download(url, fileName, 'application/json');
}
